import { PageService } from 'app/services/page-service';
import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-export-orderdata",
  templateUrl: "./export-orderdata.component.html",
  styles: [],
})
export class ExportOrderdataComponent implements OnInit {
  @Input() data: any;
  emailID = JSON.parse(localStorage.getItem('userDetails'))?.record?.emailID;
  exportDataInfo:any;
  alterEmail = '';
  errMsg = '';
  loader = false;
  exportData = false;
  constructor(
    public dialogRef: NgbActiveModal,
    public pageService: PageService
    ) {}

  ngOnInit(): void {
  this.exportDataInfo = this.data.exportDataInfo
  console.log(this.exportDataInfo);
  if((this.exportDataInfo.sellerID || this.exportDataInfo.type === 'service') && this.exportDataInfo.startDate && this.exportDataInfo.endDate){
    this.exportData =true
  }
  }

  close() {
    this.dialogRef.close({ success: false });
  }
  submit() {
    this.loader = true;
    if(this.alterEmail){
      this.exportDataInfo['emailID'] = this.alterEmail
    }
    if(!this.alterEmail){
      this.errMsg = "Please enter a valid email before submit"
      this.loader = false;
      return;
    }
    console.log(this.exportDataInfo);
    this.pageService.postMethod("order/export",this.exportDataInfo).then((response)=>{
      // console.log(response);
      this.loader = false;
    })
    this.dialogRef.close({ success: true });
  }

  sameEmail(){
    this.alterEmail = this.emailID;
  }
}
